var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-layout"},[_vm._m(0),_c('nav-header'),_c('div',{staticClass:"base-content-area"},[_c('router-view')],1),_c('login-dialog'),_c('editor'),(_vm.needFooter)?_c('system-footer'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"particle"},[_c('div',{attrs:{"id":"particle"}})])
}]

export { render, staticRenderFns }